import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {
  Carousel,
  CarouselControl,
  CarouselIndicators,
  Modal,
} from 'reactstrap';

export const Wrapper = styled.div`
  overflow-x: auto;
  height: 100%;
`;

export const LiveTextContent = styled.div`
  position: absolute;
  right: 0;
  top: 22px;
  border-radius: 8px;
  padding: 20px;
  background-color: #fff;
  width: fit-content;
z-index: 2;
  width: 322px;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));

  p {
    font-weight: 500;
    font-size: 16px;
  }
`;

export const RatingContent = styled.div`
  background-color: #fff;
  width: 100%;
  min-height: 300px;
`;

export const RatingHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #424242;
  span {
    text-align: center;
  }
`;

export const RatingBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  color: #424242;

  button {
    width: 54px;
    height: 54px;
    border: 1px solid #fff;
    border-radius: 8px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;

    :hover {
      transform: scale(1.1);
    }
  }
`;

export const SaveButton = styled.button`
  margin-top: 16px;
  border: 0;
  color: #fff;
  background-color: #ff403d;
  border-radius: 7px;
  padding: 10px 15px;
  float: right;
  :hover {
    filter: brightness(1.2);
  }
`;

export const Table = styled.table`
  width: 100%;
  margin: 10px auto 10px auto;
  border-collapse: initial;
  border-spacing: 0 20px;
  background: transparent;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  border-radius: 8px;
  padding: 0 10px;

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    tr {
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    td {
      border-bottom: 1px solid #a8b4cc;
      padding-bottom: 10px;
    }
    td:last-child {
      text-align: right;
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

export const OperationArea = styled.div`
  width: 100%;
  min-height: 500px;
  height: calc(100vh - 48px);

  display: flex;
  justify-content: space-around;
  padding: 10px;
  flex-wrap: wrap;
`;

export const TablesCardArea = styled.div`
  width: 50%;
  height: 100%;
  padding: 10px;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const OrdersCardArea = styled.div`
  width: 50%;
  height: 100%;

  padding: 10px;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const WppModal = styled(Modal)`
  .modal-content {
    width: 600px;
    border-radius: 10px;
  }

  img {
    border-radius: 10px;
  }

  h1 {
    margin: 20px 0;

    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    color: #000000;
    text-align: center;
  }

  p {
    width: 505px;
    margin: 0 auto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
  }
`;

export const ReconnectButton = styled.button`
  width: 233px;
  height: 48px;
  line-height: 48px;
  background: #ff2c3a;
  border-radius: 5px;
  border: none;
  margin: 80px auto 20px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: #ffffff;

  &:hover {
    color: #ffffff;
    text-decoration: none;
  }

  &:focus {
    color: #ffffff;
    text-decoration: none;
  }
`;

export const TablesContainer = styled.div`
  background-color: #fff;
  width: 100%;
  padding-top: 20px;

  height: calc(100vh - 155px);
  overflow: auto;
  box-shadow: 1px 0px 5px 1px rgba(0, 0, 0, 0.1);

  border-radius: 7px;
  border-top-left-radius: ${(props) => props.isFirst && '0px'};
  transition: border-radius 0.2s ease-in;
`;

export const BalconyLink = styled.button`
  border: none;
  background-color: transparent;
  font-size: 15px;
  font-weight: 600;
  color: #58ceb1;
  padding-bottom: 0px;
  text-decoration: underline;

  &:hover {
    color: #58ceb1;
    text-decoration: underline;
  }
`;

export const LinkStyled = styled(Link)`
  color: #ffb32f;
  font-weight: 700;
  text-decoration: underline;

  &:hover {
    color: #ffb32f;
    text-decoration: underline;
    filter: opacity(2);
  }

  &:active {
    color: #ffb32f;
    text-decoration: underline;
    filter: opacity(2);
  }
`;

export const TakeatModalHeader = styled.div`
  margin: auto;
`

export const TakeatModalBody = styled.div`
  flex-direction: column;
  display: flex;
  width: 388px;
  gap: 8px;
  
  > h2 {
    margin: 0;
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    font-family: 'Poppins';
  }

  > p {
    margin: 0;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    font-family: 'Poppins';
  }
`

export const TakeatModalFooter = styled.div`
  display: flex;
  gap: 47px;
  margin: auto;
`